module.exports = __webpack_public_path__ + "media/beCareful2.69cba500.mp3";